import { render, staticRenderFns } from "./gifBagStyle.vue?vue&type=template&id=79d59690&scoped=true"
import script from "./gifBagStyle.vue?vue&type=script&lang=js"
export * from "./gifBagStyle.vue?vue&type=script&lang=js"
import style0 from "./gifBagStyle.vue?vue&type=style&index=0&id=79d59690&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d59690",
  null
  
)

export default component.exports